/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import BaseUrls from '../../../../utils/baseUrls';
import { prefixPath } from '../../../../utils/helpers';
import '../../../../css/checkbox.css';
import apiBackendInstance from '../../../../utils/axios';

export type SlackChannelInput = {
  commChannelName?: string,
  organizationId?: string,
  isDefault: boolean,
  isAlertDefault: boolean,
  webhookUrl: string,
};

export type SlackChannelConfig = {
  webhookUrl: string,
};

export type CommunicationChannelBody = {
  commChannelName: string,
  commChannel: string,
  organizationId?: string,
  isDefault: boolean,
  isAlertDefault: boolean,
  authInfo: SlackChannelConfig,
  createdAtTimestamp?: string,
  updatedAtTimestamp?: string,
};

export type TestCommunicationChannelNotificationBody = {
  channel: string,
  authInfo: SlackChannelConfig,
};
type channelProps = {
  id?: string
  channel: string,
  name?: string,
  isAlert: boolean,
  isDefault: boolean,
  ownerId: string,
  authInfo?: SlackChannelConfig,
  organizationId?: string,
  onHide: ()=>void,
  isReload: ()=>void
}

const EditSlackChannelModel = (
  {
    id,
    channel,
    name,
    isAlert,
    isDefault,
    ownerId,
    organizationId,
    authInfo,
    onHide,
    isReload,
  }: channelProps,
) => {
  const [commChannelName, setCommChannelName] = useState(name);
  const commChannel = channel;
  const [webhookUrl, setWebhookUrl] = useState(authInfo?.webhookUrl);
  const [isAlertSwitch, setIsAlertSwitch] = useState(isAlert);
  const [isDefaultSwitch, setIsDefaultSwitch] = useState(isDefault);
  const [commChannelNameValidateMessage, setCommChannelNameValidateMessage] = useState(false as boolean|string);
  const [webhookUrlValidateMessage, setWebhookUrlValidateMessage] = useState(false as boolean|string);
  const [editBtnDisable, setEditBtnDisable] = useState(true);

  const baseUrl = window.location.origin;
  const theme = BaseUrls.getkey();
  const logo = baseUrl + prefixPath(`/img/${theme}/navLogo.png`);
  const spinner = baseUrl + prefixPath(`/img/${theme}/spin.svg`);
  const infoImg = baseUrl + prefixPath(`/img/${theme}/info.svg`);
  const slackIcon = baseUrl + prefixPath(`/img/${theme}/slack.svg`);

  const commChannelNameValidateHandler = (): boolean => {
    if (commChannelName && commChannelName.length > 64) {
      setCommChannelNameValidateMessage('invalid cred name, cred name length exceed 64');
      return false;
    } if (commChannelName === '' || commChannelName?.length === 0) {
      setCommChannelNameValidateMessage('Name is empty');
      return false;
    }
    return true;
  };
  const webhookUrlValidateHandler = (): boolean => {
    if (webhookUrl === '' || webhookUrl?.length === 0) {
      setWebhookUrlValidateMessage('Webhook Url is empty');
      return false;
    }
    return true;
  };
  const validate = () => {
    if (!commChannelNameValidateHandler()) return false;
    if (!webhookUrlValidateHandler()) return false;
    return true;
  };

  const editCommChannelBtn = () => {
    const spinnerDiv = document.getElementById('spinnerDiv');
    setEditBtnDisable(true);
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(BaseUrls.editUserCommunicationChannel(), {
      id,
      commChannelName,
      commChannel,
      isDefault: isDefaultSwitch,
      isAlertDefault: isAlertSwitch,
      authInfo: {
        webhookUrl,
      },
    }).then((response) => {
      const localVal = localStorage.getItem('updateChannelState');
      if (localVal && localVal === 'yes') { localStorage.setItem('updateChannelState', 'no'); } else {
        localStorage.setItem('updateChannelState', 'yes');
      }
      isReload();
      setEditBtnDisable(false);
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      const div2 = document.getElementById('succ');
      if (div2) div2.style.display = 'block';
      onHide();
    }).catch(() => {
      const localVal = localStorage.getItem('updateChannelState');
      if (localVal && localVal === 'yes') { localStorage.setItem('updateChannelState', 'no'); } else {
        localStorage.setItem('updateChannelState', 'yes');
      }
      isReload();
      setEditBtnDisable(false);
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      const div2 = document.getElementById('fail');
      if (div2) div2.style.display = 'block';
    });
  };

  const sendTestMessageChannelBtn = () => {
    const testChannelBtn: any = document.getElementById('testChannelBtn');
    const spinnerDiv = document.getElementById('spinnerDiv');
    if (testChannelBtn) {
      testChannelBtn.disabled = true;
    }
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(BaseUrls.testUserCommunicationChannelNotification(), {
      channel: commChannel,
      authInfo: {
        webhookUrl,
      },
    } as TestCommunicationChannelNotificationBody).then((response) => {
      const { data } = response;
      if (data.success) {
        if (testChannelBtn) {
          testChannelBtn.disabled = false;
        }
        if (spinnerDiv) {
          spinnerDiv.style.display = 'none';
        }
        const div2 = document.getElementById('testSucc');
        if (div2) div2.style.display = 'block';
        const div3 = document.getElementById('checkTest');
        if (div3) div3.style.display = 'block';
        setEditBtnDisable(false);
      }
    }).catch(() => {
      // setTimeout(() => { window.close(); }, 3000);
      const div3 = document.getElementById('checkTest');
      if (div3) div3.style.display = 'none';
      if (testChannelBtn) {
        testChannelBtn.disabled = false;
      }
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      const div2 = document.getElementById('testFail');
      if (div2) div2.style.display = 'block';
    });
  };
  return (
    <>
      <div id="status" />
            <main>
            <div id="succ" className="alert alert-success" style={{ display: 'none' }} role="alert">Slack communication channel successfully added.</div>
            <div id="testSucc" className="alert alert-success" style={{ display: 'none' }} role="alert">Slack communication channel message send successfully.</div>
            <div className="alert alert-danger" id="fail" style={{ display: 'none' }} role="alert">There was an error on adding the communication channel</div>
            <div className="alert alert-danger" id="testFail" style={{ display: 'none' }} role="alert">There was an error on sending test message.</div>
                <div className="d-flex justify-content-center">
                    {/* right part starts here */}
                    <section className="">
                        <div className="">
                            <div className="text-center mt-5 mb-4">
                             <img src={logo} className="img-responsive" alt="logo" />
                            </div>
                            <h6 className="mb-5 text-center">
                            Edit your
{' '}
<img
  src={slackIcon}
  height="15px"
  alt=""
/>
{' '}
{commChannel}
{' '}
Channel
<br />
Guide to generate
{' '}
{commChannel}
{' '}
Webhook -
{' '}
<a href="https://api.slack.com/messaging/webhooks" target="_blank" rel="noreferrer">
Link
</a>
                            </h6>
                            <div className=" form-floating cordaversion addCloudField d-flex">
                                <input
                                    type="text"
                                    className={`form-control addCloudField col-11 ${commChannelNameValidateMessage ? 'is-invalid' : ''}`}
                                    placeholder="Name"
                                    value={commChannelName}
                                    onChange={(e) => { setCommChannelName(e.target.value); }}
                                    onFocus={() => { setCommChannelNameValidateMessage(false); }}
                                />
                                <label htmlFor="floatingPassword" className="form-pswd">
                                    Name
                                </label>
                                <span title="Communication Channel Name to save on platform">
                                      <img className="mt-3 mx-2" src={infoImg} alt="" />
                                </span>

                            </div>
                            {commChannelNameValidateMessage !== false && (
                              <div className="text text-danger text-center">
                                            {commChannelNameValidateMessage}
                              </div>
                            )}
                            <div className=" mt-3">
                                <div className=" form-floating cordaversion d-flex ">
                                    <input
                                        type="text"
                                        className={`form-control addCloudField col-11 ${webhookUrlValidateMessage ? 'is-invalid' : ''}`}
                                        placeholder="Slack Webhook URL"
                                        value={webhookUrl}
                                        onChange={(e) => { setWebhookUrl(e.target.value); }}
                                        onFocus={() => { setWebhookUrlValidateMessage(false); }}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Slack Webhook URL
                                    </label>

                                    <span title="Slack incoming webhook url of your channel">
                                      <img className="mt-3 mx-2" src={infoImg} alt="" />
                                    </span>
                                </div>
                            </div>
                            {webhookUrlValidateMessage !== false && (
                                      <div className="text text-danger text-center">
                                            {webhookUrlValidateMessage}
                                      </div>
                            )}
                            <div className="mt-3">
                                <div className="d-flex justify-content-center">
                                    <span className="mx-4">
                                        Enable Alert
                                    </span>
                                    <Form.Check
                                      type="switch"
                                      id="isAlertDefault"
                                      name="isAlertDefault"
                                      checked={isAlertSwitch}
                                      onChange={(e) => setIsAlertSwitch(e.target.checked)}
                                    />
                                    <span className="mx-4">
                                        Default
                                    </span>
                                    <Form.Check
                                      type="switch"
                                      id="isDefault"
                                      name="isDefault"
                                      checked={isDefaultSwitch}
                                      onChange={(e) => setIsDefaultSwitch(e.target.checked)}
                                    />
                                </div>
                            </div>
                            <div id="spinnerDiv" className="text-center mx-5 p-3" style={{ position: 'absolute', display: 'none', zIndex: 10 }}>
                              <img className="mx-5" src={spinner} alt="spinnner" />
                            </div>
                            <div className="mt-4 mb-5  col-xl-12 col-lg-12 col-md-12 text-center">
                            <div id="checkTest" className="" style={{ display: 'none' }}>Check the test message in your channel. If received then proceed with saving the configuration.</div>
                                <button type="button" id="editChannelBtn" className="btn comingSoon" onClick={() => { if (validate()) editCommChannelBtn(); }}>
                                    Save
                                </button>
                                {' '}
                                <button type="button" id="testChannelBtn" className="btn comingSoon" onClick={() => { if (validate()) sendTestMessageChannelBtn(); }}>
                                    Send Test Message
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* right part ends here */}
                </div>
            </main>
    </>
  );
};

export default EditSlackChannelModel;